import { Fragment, useEffect, useRef, useState } from "react"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import config from "../config";

import { MainHeading, DocumentSection, LinkList, Text, Table, DocumentThumbnailList, DocumentThumbnailLink, Container } from "./Elements";
import ImageViewer from "./ImageViewer";
import MapView from "./MapView";

import helpers from "../helpers";
import TabContainer from "./TabContainer";
import Icon from "./Icons";

function RepositorySection(props) {
	const l = window.l;

	return props.data && props.data.id && <DocumentSection className={props.className} title={l('Repository')}>
		<LinkList>
			<span><Link to={'/safn/'+props.data.id}>{window.l(props.data.organisation)}</Link>, {window.l(props.data.place)}, {window.l(props.data.country)}</span>
		</LinkList>
	</DocumentSection>
}

function VariantsSection(props) {
	const l = window.l;

	return props.data && props.data.length > 0 && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Related documents')}>
		<DocumentThumbnailList maxCols={2}>
			{
				props.data.map((item, index) => <DocumentThumbnailLink key={index} data={item} className="bg-white" />)
			}
		</DocumentThumbnailList>
	</DocumentSection>
}

function VariantsSectionLinkList(props) {
	const l = window.l;
	const location = useLocation();

	return props.data && props.data.length > 0 && <DocumentSection className={props.className} title={l('Related documents')}>
		<LinkList blockLinks={true}>
			{
				props.data.map((item, index) => <Link key={index} to={'/archive/'+item.to_document+'/lysing'+location.search}>{item.shelfmark || item.description || window.l('(missing)')}</Link>)
			}
		</LinkList>
	</DocumentSection>
}

function ItemsSection(props) {
	const l = window.l;

	return props.data && props.data.length > 0 && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Contents')}>
		{
			props.data.map((item, index) => <div className="whitespace-pre-wrap">
				{item.item}
			</div>)
		}
	</DocumentSection>
}

function BundleSection(props) {
	const l = window.l;

	return props.data && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Bundle')}>
		<LinkList>
			<Link to={'/archive/?boggull='+props.data.key}>{window.l('Group')+' '+props.data.category+', '+window.l('bundle')+' '+props.data.bundle}</Link>
		</LinkList>
	</DocumentSection>
}

function KeywordsSection(props) {
	const l = window.l;

	return props.data && props.data.length > 0 && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Keywords')}>
		<LinkList>
			{
				props.data.map((item, index) => <Link key={index} to={'/archive/?lykilord='+item.id}>{window.l(item.keyword)}</Link>)
			}
		</LinkList>
	</DocumentSection>
}

function LangugesSection(props) {
	const l = window.l;

	return props.data && props.data.length > 0 && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Language')}>
		<LinkList>
			{
				props.data.map((item, index) => <Link key={index} to={'/archive/?tungumal='+item.id}>{window.l(item.language)}</Link>)
			}
		</LinkList>
	</DocumentSection>
}

function DocumentTypeSection(props) {
	const l = window.l;

	return props.data && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Document type')}>
		<LinkList>
			<Link to={'/archive/?tegund='+props.data}>{l(props.data)}</Link>
		</LinkList>
	</DocumentSection>
}

function OriginSection(props) {
	const l = window.l;

	return props.data && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Origin')}>
		<div className={'mb-6'}>{props.data}</div>
	</DocumentSection>
}

function ProvenanceSection(props) {
	const l = window.l;

	return props.data && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Provenance')}>
		<div className={'mb-6'}>{props.data}</div>
	</DocumentSection>
}

function ConditionSection(props) {
	const l = window.l;

	return props.data && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Condition')}>
		<div className={'mb-6'}>{props.data}</div>
	</DocumentSection>
}

function DescriptionSection(props) {
	const l = window.l;

	return props.data && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Description')}>
		<div className={'mb-6'}>{props.data}</div>
	</DocumentSection>
}

function AdditionalSection(props) {
	const l = window.l;

	return props.data && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Additional information')}>
		<div className={'mb-6 whitespace-pre-wrap'}>{props.data}</div>
	</DocumentSection>
}

const formatDate = (value) => {
	const months = [
		'',
		window.l('January'),
		window.l('February'),
		window.l('March'),
		window.l('April'),
		window.l('May'),
		window.l('June'),
		window.l('July'),
		window.l('August'),
		window.l('September'),
		window.l('October'),
		window.l('November'),
		window.l('December'),
	]
	if (value) {
		let dateSplit = value.split('-').reverse();

		//return parseInt(dateSplit[0])+'/'+(parseInt(dateSplit[1]))+'/'+dateSplit[2];

		return dateSplit.map(d => parseInt(d).toString()).join('/');

		return parseInt(dateSplit[0])+' '+window.l(months[parseInt(dateSplit[1])])+' '+dateSplit[2];
	}
	else {
		return ''
	}
}

function DatesSection(props) {
	const l = window.l;

	const getDateValue = (item) => {
		let ret = '';

		if (item.date) {
			ret = formatDate(item.date);
		}
		else if (item.year) {
			ret = item.year;
		}
		else if (item.century && item.granularity == 'century') {
			ret = item.century+'. '+l('century')+(item.century_part ? ', '+l(item.century_part) : '')
		}

		return ret;
	}

	const valueOrder = ["act", "written", "copied", "other"];

	return props.data && props.data.length > 0 && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Dates')}>
		<Table rows={props.data.filter((item) => item.date_type.type != 'acquisition').sort((a, b) => {
			return valueOrder.indexOf(a.date_type.type) - valueOrder.indexOf(b.date_type.type);
		})} columns={{
			'date': {
				heading: l('Date'),
				formatter: (value, item) => {
					return getDateValue(item)
				}
			},
			'date_type.type': {
				heading: '',
				formatter: (val) => window.l(val)
			}
		}} />
	</DocumentSection>
}

function UrlSection(props) {
	const l = window.l;

	const getBaseUrl = (url) => {
		let a = document.createElement('a');
		a.href = url;
		return a.hostname;
	}

	return props.data && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Web resources')}>
		<a className="inline-block overflow-hidden max-w-full" href={props.data}>{(props.data)}</a>
	</DocumentSection>
}

function PeopleSection(props) {
	const l = window.l;

	return props.data && props.data.length > 0 && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Persons')}>
		<Table rows={props.data} columns={{
			'name': {
				heading: l('Person name'),
				link: {
					linkField: 'name',
					linkPrefix: '/archive/?einstaklingur_nafn='
				}
			},
			'role.role': {
				heading: l('Role'),
				formatter: (val, item) => <Fragment>
					{window.l(val)}
					{
						item.second_role ? ', '+window.l(item.second_role.role) : ''
					}
					{
						item.third_role ? ', '+window.l(item.third_role.role) : ''
					}
					{item.note && <span className="text-gray-600 text-sm"><br/>{item.note}</span>}
				</Fragment>
			},
			'description': {
				heading: l('Status')
			}
		}} />
	</DocumentSection>
}

function PlacesSection(props) {
	const l = window.l;

	return props.data && props.data.length > 0 && <DocumentSection className={props.className} cardStyle={props.cardStyle}  title={l('Places')}>
		<Table rows={props.data} columns={{
			'name': {
				heading: l('Place name'),
				linkElementFunc: (item) => {
					if (item.farm != null) {
						return <Fragment>
							<Link to={'/archive?stadur='+item.farm.id}>{item.farm.name}</Link>{item.name && item.name != item.farm.name && <span className="ml-4 text-gray-800 text-sm">({item.name})</span>}
							{item.origin && <span className="ml-4 text-gray-800 text-sm">({l('place of origin')})</span>}
							{item.note && <span className="text-gray-600 text-sm"><br/>{item.note}</span>}
						</Fragment>
					}
					else {
						return <Fragment>
							<Link to={'/archive?stadarnafn='+item.name}>{item.name}</Link>
							{item.origin && <span className="ml-4 text-gray-800 text-sm">({l('place of origin')})</span>}
							{item.note && <span className="text-gray-600 text-sm"><br/>{item.note}</span>}
						</Fragment>
					}
				}
			},
			'description': {
				heading: l('Location')
			}
		}} />

		{
			helpers.placeListToMap(props.data).length > 0 && <MapView className="mt-5" mapData={helpers.placeListToMap(props.data)} />
		}

	</DocumentSection>
}

function PublicationsSection(props) {
	const l = window.l;

	return props.data && props.data.length > 0 && <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Editions')}>
		<Table rows={props.data} columns={{
			'publication.publication': {
				heading: window.l('Publication title'),
				/*
				link: {
					linkField: 'id',
					linkPrefix: '/utgafur/'
				},
				*/
				columnWidth: '50%'
			},
			'publication.volume': {
				heading: window.l('Volume')
			},
			'publication.nr': {
				heading: window.l('Nr.'),
				labelFunction: (item) => {
					if (!item.start_page && !item.end_page && item.nr) {
						return <a className="btn-sm" href={(!item.publication.base_url.toLowerCase().startsWith('http') ? '//fornbref.arnastofnun.is/django' : '')+item.publication.base_url+item.nr+(item.publication.post_url || '')} target="_blank">{item.nr} <div className="icon-lnk"></div></a>;
					}
					else {
						return item.nr;
					}
				}
			},
			'publication.start_page': {
				heading: window.l('Pages'),
				labelFunction: (item) => {
					let links = [];

					if (item.start_page) {
						for (let i = item.start_page; i<=(item.end_page || item.start_page); i++) {
							let pageNum = item.publication.page_offset ? i+item.publication.page_offset : i;
							links.push(<a className="btn-sm" href={(!item.publication.base_url.toLowerCase().startsWith('http') ? '//fornbref.arnastofnun.is/django' : '')+item.publication.base_url+pageNum+(item.publication.post_url || '')} target="_blank">{i} <div className="icon-lnk"></div></a>);
						}
					}

					return <LinkList>{links}</LinkList>
				}
			},
		}} />
	</DocumentSection>
}

function PhysicalDescriptionSection(props) {
	const l = window.l;

	const fields = [
		{
			field: 'condition',
			label: l('Condition'),
			fullWidth: true
		},
		{
			field: 'support',
			label: l('Writing support'),
			searchLinkPrefix: '/archive/?efni='
		},
		{
			field: 'text_damage',
			label: l('Text damaged')
		},
		{
			field: 'thongs_num',
			label: l('Number of thongs')
		},
		{
			field: 'thongs_holes',
			label: l('Number of thong holes')
		},
		{
			field: 'thongs_text',
			label: l('Text on thong'),
			depends_on: 'thongs_num'
		},
		{
			field: 'thongs_note',
			label: l('Note on thongs')
		},
		{
			field: 'seal_num',
			label: l('Seals, whole')
		},
		{
			field: 'seal_remnant_num',
			label: l('Seals, fragmented')
		},
		{
			field: 'seal_destroyed_num',
			label: l('Seals, only remnants')
		},
		{
			field: 'seal_note',
			label: l('Note on seals')
		},
		{
			field: 'text_damage_note',
			label: l('Note')
		}
	];

	if (props.data['support'] != 'parchment') {
		fields.push({
			field: 'watermark', // óþarfi að sýna "nei"? Vatnsmerki aldrei á skinn
			label: l('Watermark')
		});
		fields.push({
			field: 'watermark_note',
			label: l('Note on watermark')
		});
	}

	return <DocumentSection className={props.className} cardStyle={props.cardStyle} title={l('Physical description')}>
		<div className="flex flex-wrap">
			{
				fields.map(field => {
					if (props.data[field.field] && (field.depends_on ? props.data[field.depends_on] : true)) {
						return <div key={field.field} className={field.fullWidth ? 'w-full mb-4' : 'w-1/3 mb-4 pr-4'}>
							<label className="data-label">{field.label}</label>: {
								field.searchLinkPrefix ? <Link to={field.searchLinkPrefix+props.data[field.field]}>{l(props.data[field.field])}</Link> : l(props.data[field.field])
							}
						</div>
					}
				})
			}
		</div>
	</DocumentSection>
}

export default function DocumentView(props) {
	const [data, setData] = useState(null);
	const { docId, tab } = useParams();
	const location =  useLocation();

	
	const l = window.l;

	useEffect(() => {
		fetch(config.apiRoot+'document/'+docId)
			.then(res => res.json())
			.then(json => {
				setData(json);
				/*
				if (location.hash == '#myndir') {
					setTimeout(() => {
						if (imagesAnchor && imagesAnchor.current && imagesAnchor.current.scrollIntoView) {
							imagesAnchor.current.scrollIntoView();
						}
					}, 100);
				}
				*/
			});
	}, [docId]);

	return data && <Container>
		<div className="my-10">
			
			<div className="mt-5 mb-5 flex gap-5 border-b border-1 border-gray-200 pb-5">
				<Link to={'/archive/'+location.search} className="link bg-gray-50 p-2 rounded flex items-center text-md hover:bg-gray-200 transition">
					<Icon className={'text-black size-5 mr-2'} icon={'arrowLeft'} />{l('Go back to search')}
				</Link>

				<div className="grow" />

				{
					data.prev && data.prev.length > 0 && <div className="relative group">
						<Link to={'/archive/'+data.prev[0].key+'/'+(tab || 'lysing')+location.search} className="link bg-gray-50 p-2 pr-4 rounded flex items-center text-md hover:bg-gray-200 transition">
							<Icon className={'text-black size-5 mr-2'} icon={'arrowLeft'} />{data.prev[0].shelfmark}
						</Link>
						<div className="absolute top-full min-w-full bg-gray-50 py-2 px-2 rounded border shadow-md flex flex-col gap-2 pointer-events-none opacity-0 group-hover:pointer-events-auto group-hover:opacity-100 transition">
							{
								data.prev.slice(1).map((item, index) => <Link key={index} to={'/archive/'+item.key+'/'+(tab || 'lysing')+location.search}>{item.shelfmark}</Link>)
							}
						</div>
					</div>
				}

				{
					data.next && data.next.length > 0 && <div className="relative group">
						<Link to={'/archive/'+data.next[0].key+'/'+(tab || 'lysing')+location.search} className="link bg-gray-50 p-2 pl-4 rounded flex items-center text-md hover:bg-gray-200 transition">
							{data.next[0].shelfmark}<Icon className={'text-black size-5 ml-2'} icon={'arrowRight'} />
						</Link>
						<div className="absolute top-full min-w-full bg-gray-50 py-2 px-2 rounded border shadow-md flex flex-col gap-2 pointer-events-none opacity-0 group-hover:pointer-events-auto group-hover:opacity-100 transition">
							{
								data.next.slice(1).map((item, index) => <Link key={index} to={'/archive/'+item.key+'/'+(tab || 'lysing')+location.search}>{item.shelfmark}</Link>)
							}
						</div>
					</div>
				}
			</div>
			
			<MainHeading>{data.shelfmark}</MainHeading>

			<TabContainer useRouter={true} preserveSearchParams={true} selectedTab={tab || 'lysing'} baseUrl={'/archive/'+docId}>
				<div tabname="lysing" tabtitle={l('Description')} className="mt-4">

					<div className="lg:flex gap-4 print:flex-col">
				
						<div className="lg:w-2/3 print:w-full">		

							<RepositorySection data={data.repository} />

							<ItemsSection cardStyle={false} data={data.items} />

							<OriginSection data={data.origin} />

							<ProvenanceSection data={data.provenance} />

							<AdditionalSection cardStyle={false} data={data.additional} />

							<PublicationsSection cardStyle={true} data={data.document_publications} />

							<PhysicalDescriptionSection cardStyle={true} data={data} />


						</div>

						<DocumentSection cardStyle={true} className="lg:w-1/3 flex flex-col divide-y-[1px] divide-gray-200 print:w-full">

							<BundleSection data={data.bundle} className={'pt-4'} />

							<KeywordsSection data={data.keywords} className={'pt-4'} />

							<LangugesSection data={data.languages} className={'pt-4'} />

							<DocumentTypeSection data={data.document_type} className={'pt-4'} />

							<DatesSection data={data.dates} className={'pt-4'} />

							<VariantsSectionLinkList className={'pt-4'} cardStyle={false} data={data.variants} />

							<UrlSection data={data.url} className={'pt-4'} />

							<div className="flex flex-col justify-end flex-grow mb-5 pt-4">
								<div className="font-lido text-xl mb-4">{l('Notes and questions')}</div>
								<a href={'mailto:diplom@arnastofnun.is'}>diplom@arnastofnun.is</a>
							</div>

							{
								data.last_modified && <div className="text-sm text-gray-600 pt-4 flex items-end">{l('Last modified')}: {(new Date(data.last_modified)).toLocaleDateString()} {(new Date(data.last_modified)).toLocaleTimeString()}</div>
							}

						</DocumentSection>


					</div>
				
					<div className="lg:flex gap-4 print:flex-col">
				
						<PeopleSection cardStyle={true} data={data.people} className="w-full lg:w-1/2" />

						<PlacesSection cardStyle={true} data={data.places} className="w-full lg:w-1/2" />

					</div>

				</div>

				<div tabname="myndir" tabtitle={l('Images')}>

					<ImageViewer manifest={data.manifest} printImage={data.thumbnail} />

				</div>

			</TabContainer>

		</div>
	</Container>
}